import { IApplicationState } from '../../types/redux';
import { IMlReview } from '../../types/newbuildingInfo/mlReview';

export function getMasterReview(state: IApplicationState): IMlReview | null {
  return state.newbuildingInfo.mlReview;
}
